/**
 * Ryan O'Dowd
 * 2025-06-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import FormLabel from './FormLabel';
import FormRow from './FormRow';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const FormControl = (_p: FormControlProps) => {
  const styles = hooks.useStyles(getStyles);
  const props = {
    ...defaultProps,
    ..._p,
  };

  return (
    <View style={styles.outerContainer(props.disabled)}>
      <View
        style={[
          styles.container,
          props.mode === 'outlined' && styles.outlinedContainer,
          (props.mode === 'outlined' && props.isAlert) && styles.outlinedContainerAlert,
          props.addPadding && styles.addPadding,
          props.style,
        ]}
      >
        {props.children}
      </View>
      {props.label && <FormControl.Label isAlert={props.isAlert}>{props.label}</FormControl.Label>}
    </View>
  );
};

class FormControlProps {
  children: React.ReactNode;

  mode?: 'flat' | 'outlined' = 'outlined';
  addPadding?: boolean = false; // @TODO: rename this...it's only for non-select/textinputs
  style?: object;
  label?: string;
  disabled?: boolean;
  isAlert?: boolean;
};
const defaultProps = new FormControlProps();

FormControl.displayName = 'FormControl';
FormControl.Label = FormLabel;
FormControl.Row = FormRow;
export default FormControl;
